import React, {PureComponent} from 'react';
import autobind from 'autobind-decorator';
import {Col, FormCheck, Row} from 'react-bootstrap';

import {SurveyFormInputEnhance} from "./SurveyFormInputEnhance";

@SurveyFormInputEnhance
export class SurveyFormInputBoolean extends PureComponent {
    @autobind
    change(value) {
        const { SurveyFormInput } = this.props || {};

        SurveyFormInput?.Change?.(answer => ({ ...answer, valueBool: value }));
    }

    render() {
        const { Question:question, SurveyFormInput, EditMode } = this.props || {};

        const answer = SurveyFormInput.GetAnswer();
        const boolValue = answer.valueBool;
        const options = SurveyFormInput.GetOptions();
        let boolOptions = options?.boolValues ?? [];

        if(!EditMode) {
            const current = boolOptions.find((x) => x.value === boolValue);
            return <span>{current ? current.title: ""}</span>;
        }

        return <div className="sb-survey-form-input-boolean">
            {boolOptions.map((x, i) => <Row key={x.value}>
                    <Col xs={12}>
                        <FormCheck
                            id={`${question.surveyQuestionId}-${i}`}
                            checked={String(boolValue) === String(x.value)}
                            onChange={() => this.change(boolValue === x.value ? null : x.value)}
                            label={x.title}
                        />
                    </Col>
                </Row>
            )}
        </div>;
    }
}


